import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Contact } from "./Contact";

export class BillingDetail extends FormGroup {
  constructor() {
    super({
      additionalNotes: new FormControl('', Validators.maxLength(500)),
      sameAsProjectCoordinator: new FormControl(false),
      sameAsClientOrganization: new FormControl(false),
      billTo: new Contact(true),
      address: new FormControl('', [Validators.required, Validators.maxLength(255)]),
      city: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      state: new FormControl(''),
      postalCode: new FormControl('', [Validators.maxLength(20)]),
      poNumber: new FormControl('', [Validators.required, Validators.maxLength(20)]),
      poNumberNotRequired: new FormControl(false),
      jobNumber: new FormControl('', [Validators.required, Validators.maxLength(20)]),
      jobNumberNotRequired: new FormControl(false),
      promoCode: new FormControl('', Validators.maxLength(50))
    });
  }
}
